<template>
    <div v-if="category === 'OLD'">
        <span class="label label-grey font-weight-bold">
            <i class="fa fa-history"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'VEGETABLES'">
        <span class="label label-dark-green font-weight-bold">
            <i class="fa fa-carrot"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'FRUITS'">
        <span class="label label-orange font-weight-bold">
            <i class="fa fa-lemon"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'DRY_FRUITS'">
        <span class="label label-brown font-weight-bold">
            <i class="fa fa-lemon"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'FOOD_GRAIN'">
        <span class="label label-brown font-weight-bold">
            <i class="fa fa-seedling"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'PULSES'">
        <span class="label label-cyan font-weight-bold">
            <i class="fa fa-dot-circle"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'PROCESSED_ITEMS'">
        <span class="label label-teal font-weight-bold">
            <i class="fa fa-cookie"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'SPICES'">
        <span class="label label-red font-weight-bold">
            <i class="fa fa-pepper-hot"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'DAIRY'">
        <span class="label label-megna font-weight-bold">
            <i class="mdi mdi-food-variant"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'EDIBLE_OILS'">
        <span class="label label-yellow font-weight-bold">
            <i class="fa fa-oil-can"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'SALT_SUGAR_JAGGERY'">
        <span class="label label-ink font-weight-bold">
            <i class="fa fa-cubes"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'BEVERAGES'">
        <span class="label label-info font-weight-bold">
            <i class="fa fa-wine-glass"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'EXOTIC'">
        <span class="label label-light-green font-weight-bold">
            <i class="fa fa-stroopwafel"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'NON_VEG'">
        <span class="label label-brown font-weight-bold">
            <i class="fa fa-fish"/> {{ category | category }}
        </span>
    </div>
    <div v-else-if="category === 'SERVICES'">
        <span class="label label-yellow font-weight-bold">
            <i class="fa fa-hard-hat"/> Service
        </span>
    </div>
    <div v-else-if="category === 'Animal_Husbandry'">
        <span class="label label-indigo font-weight-bold">
            <i class="fa fa-dove"/> Animal Husbandry
        </span>
    </div>
    <div v-else-if="category === 'OTHERS'">
        <span class="label label-yellow font-weight-bold">
            <i class="fa fa-hard-hat"/> Others
        </span>
    </div>
  <div v-else-if="category === 'HIVE_PRODUCTS'">
        <span class="label label-brown font-weight-bold">
            <i class="fa fa-box"/> Hive Products
        </span>
  </div>
</template>

<script>
import categories from "@/data/commodityCatagories";
    // let categories = [
    //     {
    //         "name": "Others",
    //         "value": "OTHERS"
    //     },
    //     {
    //         "name": "Old",
    //         "value": "OLD"
    //     },
    //     {
    //         "name": "Service",
    //         "value": "SERVICE"
    //     },
    //     {
    //         "name": "Vegetables",
    //         "value": "VEGETABLES"
    //     },
    //     {
    //         "name": "Fruits",
    //         "value": "FRUITS"
    //     },
    //     {
    //         "name": "Dry Fruits",
    //         "value": "DRY_FRUITS"
    //     },
    //     {
    //         "name": "Food Grains",
    //         "value": "FOOD_GRAIN"
    //     },
    //     {
    //         "name": "Pulses",
    //         "value": "PULSES"
    //     },
    //     {
    //         "name": "Processed Items",
    //         "value": "PROCESSED_ITEMS"
    //     },
    //     {
    //         "name": "Spices",
    //         "value": "SPICES"
    //     },
    //     {
    //         "name": "Dairy",
    //         "value": "DAIRY"
    //     },
    //     {
    //         "name": "Edible Oils",
    //         "value": "EDIBLE_OILS"
    //     },
    //     {
    //         "name": "Salt Sugar Jaggery",
    //         "value": "SALT_SUGAR_JAGGERY"
    //     },
    //     {
    //         "name": "Beverages",
    //         "value": "BEVERAGES"
    //     },
    //     {
    //         "name": "Exotic",
    //         "value": "EXOTIC"
    //     },
    //     {
    //         "name": "Non Veg",
    //         "value": "NON_VEG"
    //     },
    //     {
    //         "name": "Animal Husbandry",
    //         "value": "Animal_Husbandry"
    //     }
    // ];

    export default {
        name: "GoodsServicesCategory",
        props: ["category"]
    }
</script>

<style scoped>

</style>
